import React from 'react';
import Reflux from 'reflux';
import GongqiFormItem from './GongqiFormItem';
import FormItemConst from './FormItemConst';
import ToolBarPrintStore from '../stores/ToolBarPrintStore';
import {FocusSetStore} from '../stores/FocusStore';
import {SetButtonStyleStore,CmdUpdateControlAllowEditStore,CmdUpdateControlLabelStore} from '../stores/CmdTypeStore';
import FocusActions from '../actions/FocusActions';

require('../styles/FormItemButton.css');

class FormItemMenuItemButton extends GongqiFormItem
{
	constructor(props) {
		super(props);
		this.unsubscribeTestStore = ToolBarPrintStore.listen(this.onPrint.bind(this));
		this.unsubscribeFocusSetStore = FocusSetStore.listen(this.onFocusSet.bind(this));
		this.unsubscribeSetButtonStyleStore = SetButtonStyleStore.listen(this.onSetButtonStyle.bind(this));
		this.unsubscribeCmdUpdateControlAllowEditStore = CmdUpdateControlAllowEditStore.listen(this.onCmdUpdateControlAllowEditStore.bind(this));
		this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel.bind(this));
		this.state.devStyles = {};
		this.state.label = this.props.label;
	}

	componentWillUnmount()
	{
		this.unsubscribeTestStore();
		this.unsubscribeFocusSetStore();
		this.unsubscribeSetButtonStyleStore();
		this.unsubscribeCmdUpdateControlAllowEditStore();
		this.unsubscribeCmdUpdateControlLabelStore();
	}

	onCmdUpdateControlLabel(name,_label,moduleInstanceId)
	{
		if(name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.setState({label:_label});
		}
	}

	onFocusSet(formId,itemId,pre,init)
	{
		//alert(itemId + "  " + this.props.xml.id);
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			$(this.btn).focus();
			//$(this.inputField).select();
		}
	}

	onSetButtonStyle(formId,name,buttonStyle)
	{
		if(this.props.xml.name == name && this.props.formId == formId)
		{
			this.setState({devStyles:buttonStyle});
		}
	}

	onCmdUpdateControlAllowEditStore(name,_allowEdit,moduleInstanceId)
	{
		if(name == this.props.xml.name && this.props.moduleInstanceId == moduleInstanceId)
		{
			var finalAllowEdit = this.props.control.getProperty_AllowEdit_Final();
			if(!finalAllowEdit)$(this.btn).attr("disabled",true);
			else $(this.btn).removeAttr("disabled");

		}
	}

	onPrint(_value)
	{
		alert(_value);
	}

	//当时此button在下拉框上 属于第三极IFrame
	testIframeToParentAction()
	{
		if(this.isclicking == true)
		{
			return;
		}

		this.isclicking = true;
		let _that = this;
		let _id = setTimeout(function(e){

						clearTimeout(_id);
						_that.isclicking = false;

				  },1000);

		if(typeof(this.props.clickHandler)=="function")
			this.props.clickHandler();
		return;
		alert(window.menuItemId+window.formId);
		return;
		var _parentWindow = window.parent.window;
		if(_parentWindow)
		{
			if(typeof(_parentWindow.lookupReturnTest)=='function')
				_parentWindow.lookupReturnTest();
		}
		//window.parent.window.filterNodesBySubPage("SJLJ")
	}

	onKeyDownHandler(e)
	{
		if(9===e.keyCode)
		{
			//alert(e.shiftKey)
			e.preventDefault();
			FocusActions.focusChange(this.props.xml,e.shiftKey);
		}
	}

	inputFieldFocus()
	{
		window.lastFocusUI = this.btn;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
	}

	componentDidMount()
	{
		var _allowEdit = this.props.control.getProperty_AllowEdit_Final();
		if(!_allowEdit)$(this.btn).attr("disabled","disabled");
		else $(this.btn).removeAttr("disabled");
	}

	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		if(_style!=undefined)
		{
			_style['margin'] = '3px';_style.position = 'relative';
		}
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		Object.assign(_style,this.state.devStyles);
		if(this.props.iconClass)
		{
			return <button id={this.props.xml.name} ref={node => this.btn = node} className='btn btn-info GongqiFormItemMenuItemButton' onKeyDown={this.onKeyDownHandler.bind(this)} onFocus={this.inputFieldFocus.bind(this)}
				onClick={this.testIframeToParentAction.bind(this)} style={_style}><i className={this.props.iconClass}></i>&nbsp;{this.state.label}<i className={"fa fa-angle-right"} aria-hidden="true" style={{position:'absolute',right:'8px'}}></i></button>;	
		}
		else
		{
			return <button id={this.props.xml.name} ref={node => this.btn = node} className='btn btn-info GongqiFormItemMenuItemButton' onKeyDown={this.onKeyDownHandler.bind(this)} onFocus={this.inputFieldFocus.bind(this)}
				onClick={this.testIframeToParentAction.bind(this)} style={_style}>{this.state.label}<i className={"fa fa-angle-right"} aria-hidden="true" style={{position:'absolute',right:'8px'}}></i></button>;
		}
	}
	
};

FormItemMenuItemButton.defaultProps = {
};

export default FormItemMenuItemButton;


// WEBPACK FOOTER //
// ./src/formItem/FormItemMenuItemButton.js